<table
  [attr.style]="dashboardTableClassOverride"
  [class.newsite]="showNewDesign"
  [class.seven-pods]="showOrdersLastWeek"
>
  <tr>
    <td>
      <jfw-wholesale-data-pod
        id="this-week"
        headerlabel="Orders This Week"
        contenttext="{{ thisWeek?.itemCount }}"
        [theme]="themeFor('dp no-drop-shadow')"
        showbottomarrow="true"
        enablespinner="true"
        arrowIgnoresSpinner="false"
        (podClick)="handlePodClick($event)"
        [parent_application]="parent_application"
        [environment]="environment"
        active="false"
      ></jfw-wholesale-data-pod>
    </td>
    <td>
      <jfw-wholesale-data-pod
        id="next-week"
        headerlabel="Orders Next Week"
        contenttext="{{ nextWeek?.itemCount }}"
        [theme]="themeFor('dp no-drop-shadow')"
        showbottomarrow="true"
        enablespinner="true"
        arrowIgnoresSpinner="false"
        (podClick)="handlePodClick($event)"
        [parent_application]="parent_application"
        [environment]="environment"
        active="false"
      ></jfw-wholesale-data-pod>
    </td>
    @if (showOrdersLastWeek) {
      <td>
        <jfw-wholesale-data-pod
          id="last-week"
          headerlabel="Orders Last Week"
          contenttext="{{ lastWeek?.itemCount }}"
          [theme]="themeFor('dp no-drop-shadow')"
          showbottomarrow="true"
          enablespinner="true"
          arrowIgnoresSpinner="false"
          (podClick)="handlePodClick($event)"
          [parent_application]="parent_application"
          [environment]="environment"
          active="false"
        ></jfw-wholesale-data-pod>
      </td>
    }
    <td>
      <jfw-wholesale-data-pod
        id="late-return"
        headerlabel="Orders Late Return"
        contenttext="{{ lateReturn?.itemCount }}"
        [theme]="themeFor('dp no-drop-shadow')"
        showbottomarrow="true"
        enablespinner="true"
        arrowIgnoresSpinner="false"
        (podClick)="handlePodClick($event)"
        [parent_application]="parent_application"
        [environment]="environment"
      ></jfw-wholesale-data-pod>
    </td>
    <td>
      <jfw-wholesale-data-pod
        id="missing-size"
        headerlabel="Orders Missing Size"
        contenttext="{{ missingSize?.itemCount }}"
        [theme]="themeFor('dp no-drop-shadow')"
        showbottomarrow="true"
        enablespinner="true"
        arrowIgnoresSpinner="false"
        (podClick)="handlePodClick($event)"
        [parent_application]="parent_application"
        [environment]="environment"
      ></jfw-wholesale-data-pod>
    </td>
    <td>
      <jfw-wholesale-data-pod
        id="duplicate-orders"
        headerlabel="Possible Duplicates"
        contenttext="{{ possibleDuplicates?.itemCount }}"
        [theme]="themeFor('dp no-drop-shadow')"
        showbottomarrow="true"
        enablespinner="true"
        arrowIgnoresSpinner="false"
        (podClick)="handlePodClick($event)"
        [parent_application]="parent_application"
        [environment]="environment"
      ></jfw-wholesale-data-pod>
    </td>
    <td>
      <jfw-wholesale-data-pod
        id="potential-events"
        headerlabel="Customer Leads"
        contenttext="{{ potentialEvents?.itemCount }}"
        [theme]="themeFor('purple no-drop-shadow')"
        showbottomarrow="true"
        enablespinner="true"
        arrowIgnoresSpinner="false"
        (podClick)="handlePodClick($event)"
        [parent_application]="parent_application"
        [environment]="environment"
      ></jfw-wholesale-data-pod>
    </td>
  </tr>
</table>
@if (showRefreshControl && podsLastUpdated() !== 0) {
  @if (parent_application === "dealerportal" && newSite) {
    <div class="refresh-control newsite">
      <button
        type="button"
        (click)="fetchData(true)"
        class="refresh-button"
      >
        <mat-icon>refresh</mat-icon>
        Refresh Data
      </button>
      <span class="last-updated">
        Last Updated: {{ getPrettyDate(podsLastUpdated() ?? 0) }}
      </span>
    </div>
  } @else {
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: left;
        gap: 12px;
        margin-top: 5px;
        margin-left: 10px;
      "
    >
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="fetchData(true)"
        style="font-size: 10px !important"
      >
        <mat-icon style="margin-right: 4px">refresh</mat-icon>
        Refresh Data
      </button>

      <p
        class="refresh-note"
        style="
          font-family: Figtree, sans-serif;
          font-size: 1em;
          font-weight: 400;
        "
      >
        <strong>Last Updated: </strong>
        {{ getPrettyDate(podsLastUpdated() ?? 0) }}
      </p>
    </div>
  }
}
